import invalidIcon from '../../assets/images/icon-invalid.png';

const ErrorMessage = ({message, showButton}) => {
    const render = (message) => {
        return {__html: message}
    }
    const back = () => {

    };

    return <div className="container app-err">
        <div className="row">
            <div className="d-flex justify-content-center mt-5 mb-5">
                <div className="app-err-icon">
                    <img src={invalidIcon} alt={``}/>
                </div>
            </div>
        </div>
        <div className="row justify-content-center mb-5">
            <div className="col-md-12 col-lg-8">
                <h2 className="error"
                    style={{
                        textAlign: `center`,
                        fontWeight: 500,
                        fontFamily: `Open Sans`,
                        textWrap: 'pretty',
                        fontSize: '19px'
                    }}
                    dangerouslySetInnerHTML={render(message)}/>
                {showButton && <div className="button">
                    <button onClick={back}>Back to Home</button>
                </div>}
            </div>
        </div>
    </div>
};

export default ErrorMessage;
